// @flow

import GenericRelationResource from 'speed-js-core/src/api/resources/GenericRelationResource';

export default class ServiceResellerGenericResource extends GenericRelationResource {
    basePath: string = 'services/service-reseller/{appLabel}/{contentType}/{objectId}/';

    objectPath: string = 'services/service-reseller/{appLabel}/{contentType}/{objectId}/{ident}/';
}
